export default __webpack_public_path__ + "static/media/map-pin-grey.d456ed60.svg";